"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _heroBrand = _interopRequireDefault(require("../styles/hero-brand.css"));
var applyDarkTheme = function applyDarkTheme(data, theme) {
  return data.theme === 'dark' ? theme[data.theme] : '';
};
var HeroBackgroundVideoButton = function HeroBackgroundVideoButton(_ref) {
  var data = _ref.data,
    videoIsPlaying = _ref.videoIsPlaying,
    toggleVideoPlay = _ref.toggleVideoPlay,
    theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: applyDarkTheme(data, theme) + " " + _heroBrand["default"].buttonWrapper
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: _heroBrand["default"].videoControlsButton + " " + theme.dark,
    onClick: function onClick() {
      return toggleVideoPlay(videoIsPlaying);
    },
    name: videoIsPlaying ? 'Pause' : 'Play',
    "aria-label": videoIsPlaying ? 'Pause' : 'Play'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "aria-hidden": "true",
    className: (videoIsPlaying ? theme.mmcIconPause : theme.mmcIconPlay) + " " + _heroBrand["default"].videoControlsIcon + " "
  })));
};
var _default = HeroBackgroundVideoButton;
exports["default"] = _default;